<script setup>
defineProps(["catName", "ccy", "srv"]);

const numberFormat = new Intl.NumberFormat(document.documentElement.lang);
</script>

<template>
	<a :href="`booking/${srv.srv_id}`" class="vix-srv-card elevated hover">
		<div class="image">
			<img
				loading="lazy"
				:src="`/api/srv/${srv.srv_id}/img/logo?v=${srv.updated}`"
				:alt="$gettext('Schedule appointment for %1 with %2', srv.title, srv.org_name)"
			>
			<div class="methods">
				<i v-if="srv.video" class="fa-duotone fa-circle-video fa-fw"></i>
				<span v-if="srv.office" class="fa-stack">
					<i class="fa-solid fa-circle fa-stack-2x"></i>
					<i class="fa-solid fa-building fa-stack-1x"></i>
				</span>
				<i v-if="srv.phone" class="fa-duotone fa-circle-phone fa-fw"></i>
			</div>
			<div v-if="catName" class="cat-name">{{ catName }}</div>
		</div>
		<div class="details grid gap-8">
			<div class="title-wrapper">
				<h2 class="srv-title">{{ srv.title }}</h2>
				<div class="org vui-hgap-4">
					<i v-if="srv.publish > 0" class="fa-solid fa-badge-check"></i>
					<div class="name">{{ srv.org_name }}</div>
					<template v-if="srv.rating">
						<i class="fa-solid fa-star"></i>
						<div>{{ numberFormat.format(srv.rating) }}</div>
						<div>({{ numberFormat.format(srv.rating_cnt) }})</div>
					</template>
				</div>
			</div>
			<div class="srv-descr">{{ srv.descr.substring(0, 240) }}</div>
			<div>
				<hr>
				<div class="srv-footer">
					<div v-if="srv.pack" class="duration">{{ $pgettext("minutes x quantity", "%1 min x %2", Math.round(srv.duration / 60), srv.pack + 1) }}</div>
					<div v-else class="duration">{{ $pgettext("minutes", "%1 min", Math.round(srv.duration / 60)) }}</div>
					<div class="price">{{ srv.price !== null ? $lcurrency(srv.price, ccy) : $gettext("Free") }}</div>
				</div>
			</div>
		</div>
	</a>
</template>
